// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2kh8i","productName":"Table_productName__2VmKC"};